import { ClientAddress } from "@/lib/api";
import { formatCep } from "@/lib/formatters";

/** Campos usados para exibir um endereço; também montados a partir do endereço legado do cliente. */
export type AddressLinesSource = Pick<
  ClientAddress,
  "street" | "number" | "complement" | "district" | "city" | "state" | "postcode"
>;

/** "Rua, número". */
export const addressStreetLine = (address: AddressLinesSource) =>
  [address.street, address.number].filter(Boolean).join(", ");

/** "Complemento - Bairro, Cidade/UF, CEP 00000-000", sem as partes vazias. */
export const addressDetailsLine = (address: AddressLinesSource) =>
  [
    [address.complement, address.district].filter(Boolean).join(" - "),
    [address.city, address.state].filter(Boolean).join("/"),
    address.postcode ? `CEP ${formatCep(address.postcode)}` : "",
  ]
    .filter(Boolean)
    .join(", ");

/** Endereço numa linha só (PDF do pedido): "Rua, número, Complemento - Bairro, Cidade/UF, CEP 00000-000". */
export const addressSingleLine = (address: AddressLinesSource) =>
  [addressStreetLine(address), addressDetailsLine(address)].filter(Boolean).join(", ");
